import { msg } from '@gonfalon/messages/msg';
import type { MetricEventUrlKind } from '@gonfalon/metrics/types';

export const URL_MATCHER_KINDS: MetricEventUrlKind[] = ['canonical', 'exact', 'regex', 'substring'];

const URL_MATCHER_KIND_DISPLAY_NAME_IDS = {
  canonical: 'metrics.targetUrls.simpleMatch',
  exact: 'metrics.targetUrls.exactMatch',
  regex: 'metrics.targetUrls.regularExpression',
  substring: 'metrics.targetUrls.substringMatch',
} as const satisfies Record<MetricEventUrlKind, string>;

export function urlMatcherKindDisplayName(kind: MetricEventUrlKind): string {
  return msg(URL_MATCHER_KIND_DISPLAY_NAME_IDS[kind]);
}

export function isAbsoluteUrl(url: string) {
  return /^(?:\w+:)?\/\//.test(url.toString());
}

export interface MetricUrlAccessDecision {
  isAllowed: boolean;
  getModifyFieldReason(): string;
}

export function allowDecision(): MetricUrlAccessDecision {
  return {
    isAllowed: true,
    getModifyFieldReason() {
      return '';
    },
  };
}
